document.addEventListener("DOMContentLoaded", () => {
  let isScrollingToTarget = false;

  document.querySelectorAll(".scrolling-collage").forEach((container) => {
    const navList = container.querySelector(".scrolling-collage-nav");

    if (!navList) return;

    function handleScrollHighlight() {
      if (isScrollingToTarget) return;

      const navItems = Array.from(navList.children);
      if (navItems.length === 0) return;

      const sections = navItems.map((li) => {
        const link = li.querySelector('a[href^="#"]');
        if (!link) return null;
        const anchor = link.getAttribute("href")?.substring(1);
        if (!anchor) return null;
        return document.getElementById(anchor);
      });

      const scrollY = window.scrollY;
      const viewportMiddle = scrollY + window.innerHeight / 2;

      let activeIndex = 0;
      for (let i = 0; i < sections.length; i++) {
        const section = sections[i];
        if (!section) continue;
        const rect = section.getBoundingClientRect();
        const sectionTop = scrollY + rect.top;
        if (viewportMiddle >= sectionTop) {
          activeIndex = i;
        }
      }

      navItems.forEach((li, i) => {
        const link = li.querySelector("a");

        if (link) {
          const classes = link.dataset.activeClass?.split(" ").filter((i) => i);

          if (i === activeIndex) {
            link.classList.add(...classes);

            const btn = li.querySelector("a");
            const tabList = li.closest(".scrolling-collage-nav");

            if (btn && tabList && typeof tabList.scrollTo === "function") {
              const btnCenter = btn.offsetLeft + btn.offsetWidth / 2;
              const listCenter = tabList.offsetWidth / 2;
              tabList.scrollTo({
                left: btnCenter - listCenter,
                behavior: "smooth"
              });
            }
          } else {
            link.classList.remove(...classes);
          }
        }
      });
    }

    document
      .querySelectorAll('.scrolling-collage-nav a[href^="#"]')
      .forEach((anchorLink) => {
        anchorLink.addEventListener("click", (event) => {
          const href = anchorLink.getAttribute("href");
          const targetId = href?.substring(1);
          if (!targetId) return;

          const target = document.getElementById(targetId);
          if (target) {
            event.preventDefault();
            const targetTop =
              target.getBoundingClientRect().top + window.scrollY;
            const scrollDirectionDown = targetTop > window.scrollY;
            window.scrollBy(0, scrollDirectionDown ? 1 : -1);

            isScrollingToTarget = true;
            requestAnimationFrame(() => {
              setTimeout(() => {
                isScrollingToTarget = false;
                handleScrollHighlight();
              }, 600);

              setTimeout(() => {
                target.scrollIntoView({ behavior: "smooth" });
              }, 50);
            });
          }
        });
      });

    window.addEventListener("scroll", handleScrollHighlight, { passive: true });
    window.addEventListener("resize", handleScrollHighlight);
    handleScrollHighlight();
  });
});
